export const LOGIN_REQUESTED = 'LOGIN_REQUESTED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const UPDATE_USER_SESSION = 'UPDATE_USER_SESSION'
export const REGISTER_REQUESTED = 'LOGIN_REQUESTED'
export const REGISTER_SUCCESS = 'LOGIN_SUCCESS'
export const REGISTER_FAILED = 'LOGIN_FAILED'
export const CREATEAPP_REQUESTED = 'CREATEAPP_REQUESTED'
export const CREATEAPP_SUCCESS = 'CREATEAPP_SUCCESS'
export const CREATEAPP_FAILED = 'CREATEAPP_FAILED'
export const LIST_GITHUB_REPOS = 'LIST_GITHUB_REPOS'
export const STORE_GITHUB_TOKEN = 'STORE_GITHUB_TOKEN'
export const LOGOUT = 'LOGOUT'
export const UPDATE_SUBSCRIPTION_INFO = 'UPDATE_SUBSCRIPTION_INFO'
export const AUTHORIZED_CHAT = 'AUTHORIZED_CHAT'
